var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.files),function(file,index){return _c('div',{key:index,staticClass:"files",class:{ 'files--added': _vm.acceptedFilesIds.includes(file?.file?.id) },on:{"click":function($event){return _vm.addFile(file)}}},[_c('span',[_vm._v(_vm._s(file.file.name))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }